import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import { useForClubsAudience } from '@/hooks/useForClubsAudience'
import { getHeaderMenuItems } from '@/ui/Header/headerMenuItems'
import type { HeaderMenuItemResolved } from '@/ui/Header/types'

export function useHeaderMenuItems(): HeaderMenuItemResolved[] {
  const t = useTranslations('header')
  const { showForClubsNavLink } = useForClubsAudience()

  return useMemo(
    () =>
      getHeaderMenuItems(showForClubsNavLink).map(item => ({
        href: item.href,
        disabled: item.disabled,
        label: t(item.labelKey!)
      })),
    [showForClubsNavLink, t]
  )
}
